import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';




export const shipmentEngineerProductOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    //menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "商品名称",
            prop: "name",
            type: "input",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "一级分类",
            prop: "firstClassifyName",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "二级分类",
            prop: "secondClassifyName",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label:'图片',
            prop:'img',
            type:'upload',
            // imgWidth:100,
            listType:'picture-img'
        },
        // {
        //     label: "图片",
        //     prop: "img",
        //     span: 24,
        //     // // hide: true,
        //     // solt: true,
        //     formsolt: true,
        //     editVisdiplay: false,
        //     listType:'picture-img',
        //     type:'upload',
        //     rules: [{
        //         required: true,
        //         trigger: "blur",
        //         message: "请上传商品图片"
        //     }]
        // },
        {
            label: '单位',
            prop: 'unit',
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: '初始库存',
            prop: 'initialNumber',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '现有库存',
            prop: 'goodsNumber',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "最新出货时间",
            prop: "updateTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '单价',
            prop: 'price',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '总价',
            prop: 'totalPrice',
            addVisdiplay: false,
            editVisdiplay: false
        }
    ]
};